import { Box, Button } from "@mui/material";
import {
  useRouteMatch,
  useLocation
} from "react-router-dom"; 
import React from "react";

function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

export default function Wallets() {
    let {url}  = useRouteMatch();
    let query = useQuery();
    
    let urlParts = url.split ('/');
    let action = urlParts.length > 2 ? urlParts[2].toLowerCase() : "unknown"
    console.log (`Action: ${action}`)
    const redirectURI = query.get("redirectUri")

    function handleConnectButton () {
        //redirect to redirectURI
        if (redirectURI != null) {
            window.location.replace(redirectURI); 
        }
            
    }

    switch (action) {
        case "create":
            return (
                <Box>

                </Box>
            );
        case "link":
            return (
                <Box>
                    <Box>
                        Show list address 
                    </Box>
                    <Box>
                        <Button color="primary" variant="contained"  onClick={handleConnectButton}>Connect</Button>
                    </Box>
                </Box>
            );
        case "claim":
            return (
                <Box>
                </Box>    
            );
        case "manage":
            return ( 
                <Box>
                </Box>
            );
        default:
            break;
    }
    
    return (
        <Box>
            <Box>
                Wallets action is not supported. URL: {url}  {query.get("name")}
            </Box>
        </Box>
    );
}